import {
  Button,
  Container,
  Heading,
  HStack,
  Icon,
  Input,
  Stack,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  Text,
  Box,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiArrowDropLeftLine, RiArrowDropRightLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Layout from "../../../components/student/Layout/layout";
import ExamEllipses from "../../../containers/student/exams/exam-ellipses";
import ExamQuestions from "../../../containers/student/exams/exam-questions";
import Timer from "../../../containers/student/exams/timer";
import useExamSchedule from "../../../containers/student/exams/use-exam-schedule";
import ExamAnswersLoading from "../../../containers/student/models/exam-answers-loading";
import { saveExamSubmitMessage } from "../../../helpers/examSubmitMessage";
import {
  closeExamAnswersLoading,
  openExamAnswersLoading,
} from "../../../modules/admin-modules/models/Actions";
import {
  getExamQuestionsRequest,
  getExamsByIdRequest,
  sendAnswersRequest,
} from "../../../modules/students-modules/exams/Actions";
import { getStudentExamQuestionsRequest } from "../../../modules/students-modules/student-exams/Actions";

const SolveExam = () => {
  const [examQuestions, setExamQuestions] = useState([]);
  const dispatch = useDispatch();
  const queryString = require("query-string");
  const parsed = queryString.parse(window.location.search);
  const examId = window.location.pathname.includes("student")
    ? window.location.pathname.split("/")[3]
    : window.location.pathname.split("/")[2];
  const examQuestionsData = useSelector(
    (state) => state.chapterExams.examQuestions
  );
  const studentExamQuestions = useSelector(
    (state) => state.studentExams.examQuestions
  );

  const [answers, setAnswers] = useState([]);
  const [selectedQuestionIdx, setSelectedQuestionIdx] = useState(0);
  const [studentPdf, setStudentPdf] = useState(null);
  const exam = useSelector((state) => state.chapterExams.exam);
  const schedule = useExamSchedule(exam);
  const isLoading = useSelector((state) => state.chapterExams.isLoading);
  const { isOpen, onOpen, onClose } = useDisclosure();
  // useBeforeunload((event) => {
  //   if (Object.keys(answers)?.length != examQuestions?.length) {
  //     event.preventDefault();
  //     return "you will lose your data";
  //   }
  // });
  useEffect(() => {
    if (examId) {
      dispatch(getExamsByIdRequest(examId));
      if (window.location.pathname.includes("student")) {
        dispatch(getStudentExamQuestionsRequest(examId));
      } else {
        dispatch(getExamQuestionsRequest(examId));
      }
    }
  }, [examId, window.location.pathname]);

  useEffect(() => {
    if (window.location.pathname.includes("student")) {
      setExamQuestions(studentExamQuestions);
    } else {
      setExamQuestions(examQuestionsData);
    }
  }, [studentExamQuestions, examQuestionsData]);

  const handelNextQuestion = () => {
    if (selectedQuestionIdx < 0)
      setSelectedQuestionIdx(examQuestions?.length - 1);
    else if (selectedQuestionIdx >= examQuestions?.length - 1)
      setSelectedQuestionIdx(0);
    else setSelectedQuestionIdx((s) => s + 1);
  };
  const handelPrevQuestion = () => {
    if (selectedQuestionIdx > examQuestions?.length - 1)
      setSelectedQuestionIdx(0);
    if (selectedQuestionIdx <= 0)
      setSelectedQuestionIdx(examQuestions?.length - 1);
    else setSelectedQuestionIdx((s) => s - 1);
  };

  const isPdfEssayExam = String(exam?.essay_type) === "1";
  const isEssayTextQuestion = (question) =>
    String(exam?.essay_type) === "0" && String(question?.type) === "1";
  const isEssayQuestion = (question) => String(question?.type) === "1";

  const questionCount = examQuestions?.length ?? 0;
  const essayQuestionCount = examQuestions.filter((question) =>
    isEssayQuestion(question)
  ).length;
  const isLastQuestion = questionCount > 0 && selectedQuestionIdx === questionCount - 1;
  const hasAnsweredAll =
    questionCount > 0 &&
    examQuestions.every((question, i) => {
      if (isPdfEssayExam && isEssayQuestion(question)) return true;
      const answer = answers[i];
      if (!answer) return false;
      if (isEssayTextQuestion(question)) {
        return Boolean(String(answer.essay_answer || "").trim());
      }
      return Boolean(answer.answer_id);
    });
  const showSubmitButton = hasAnsweredAll && (!isPdfEssayExam || isLastQuestion);

  const handlePdfChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setStudentPdf(null);
      return;
    }
    const isPdf =
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf");
    if (!isPdf) {
      toast.error("Please upload a PDF file");
      e.target.value = "";
      setStudentPdf(null);
      return;
    }
    setStudentPdf(file);
  };

  const handelSendAnswers = async () => {
    if (isPdfEssayExam && !studentPdf) {
      toast.error("Please upload a PDF before submitting");
      onOpen();
      return;
    }

    dispatch(openExamAnswersLoading());
    const action = (response) => {
      dispatch(closeExamAnswersLoading());
      window.localStorage.removeItem("startTime");
      saveExamSubmitMessage(response);
      window.location.href = window.location.pathname.includes("student")
        ? "/student/exams"
        : "/exams/sections";
    };

    let formData = new FormData();
    await formData.append("exam_id", examId);
    if (isPdfEssayExam && studentPdf) {
      formData.append("student_pdf", studentPdf);
    }

    examQuestions.forEach((question, index) => {
      const data = answers[index];
      const questionId = data?.question_id || question?.id;
      if (!questionId) return;

      formData.append(`answers[${index}][question_id]`, questionId);

      if (isPdfEssayExam && isEssayQuestion(question)) {
        return;
      }

      if (data && Object.prototype.hasOwnProperty.call(data, "essay_answer")) {
        formData.append(`answers[${index}][essay_answer]`, data.essay_answer);
      } else if (data?.answer_id != null && data.answer_id !== "") {
        formData.append(`answers[${index}][answer_id]`, data.answer_id);
      }
    });

    dispatch(sendAnswersRequest(formData, action));
  };

  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      {/* <Beforeunload onBeforeunload={() => "You’ll lose your data!"} /> */}

      <Container
        maxW="container.xl"
        h="100%"
        my="100px"
        mb="165px"
        w="100%"
        onSelect={(e) => {
          const tag = e.target?.tagName;
          if (tag === "TEXTAREA" || tag === "INPUT") return;
          e.preventDefault();
        }}
        onMouseDown={(e) => {
          const tag = e.target?.tagName;
          if (tag === "TEXTAREA" || tag === "INPUT") return;
          e.preventDefault();
        }}
      >
        <VStack spacing={"70px"} h="100%" w="100%" mt={20}>
          <Heading
            as="h3"
            color="main_1"
            textAlign="center"
            w="100%"
            textTransform="capitalize"
          >
            {parsed?.name}
          </Heading>
          {(schedule.startsIn || schedule.closesIn || schedule.afterEnd) && (
            <VStack spacing={1} mt="-40px !important">
              {schedule.startsIn && (
                <Text fontWeight="700" color="main_1">
                  Starts in {schedule.startsIn}
                </Text>
              )}
              {schedule.closesIn && (
                <Text fontWeight="700" color="main_1">
                  Time left {schedule.closesIn}
                </Text>
              )}
              {schedule.afterEnd && (
                <Text fontWeight="700" color="red.500">
                  Exam closed
                </Text>
              )}
            </VStack>
          )}
          {isPdfEssayExam && essayQuestionCount > 0 && (
            <Box
              w="100%"
              maxW="800px"
              bg="blue.50"
              border="1px solid"
              borderColor="blue.200"
              borderRadius="12px"
              p={4}
              mt="-40px !important"
            >
              <Text fontWeight="700" color="main_1" mb={1}>
                This exam has {essayQuestionCount} essay{" "}
                {essayQuestionCount === 1 ? "question" : "questions"}
              </Text>
              <Text fontSize="15px" color="gray.700" lineHeight="1.6">
                Write your essay answers in a PDF. Submit Answers will appear on
                the last question so you can upload the file.
              </Text>
            </Box>
          )}
          {exam?.timer == 1 && (
            <Timer
              time={exam?.time}
              handelSendAnswers={() => {
                if (isPdfEssayExam && !studentPdf) {
                  onOpen();
                  return;
                }
                handelSendAnswers();
              }}
            />
          )}
          {/* questions polts */}
          <HStack>
            <Icon
              as={RiArrowDropLeftLine}
              onClick={handelPrevQuestion}
              fontSize="35px"
            />

            <ExamEllipses
              answeredQ={Object.keys(answers)}
              questionsCount={examQuestions?.length}
              setSelectedQuestionIdx={setSelectedQuestionIdx}
              selectedQuestionIdx={selectedQuestionIdx}
            />
            <Icon
              as={RiArrowDropRightLine}
              onClick={handelNextQuestion}
              fontSize="35px"
            />
          </HStack>

          <Stack flexDir={{ base: "column", md: "row" }} alignItems="end" spacing={4} w="100%">
            {/* questions */}
            <Box flex={1} w="100%">
              <ExamQuestions
                data={examQuestions[selectedQuestionIdx]}
                setAnswers={setAnswers}
                answers={answers}
                selectedQuestionIdx={selectedQuestionIdx}
                essayType={exam?.essay_type}
              />
            </Box>

            {/* buttons */}
            <VStack spacing={3} alignItems="stretch" minW="200px" m={4} p={4}>
              {questionCount > 1 && !(isPdfEssayExam && isLastQuestion) && (
                <Button onClick={handelNextQuestion} bg="main_1" color="white" w="100%" size="md">
                  Next Question
                </Button>
              )}
              {showSubmitButton && (
                <Button onClick={onOpen} bg="green.500" color="white" w="100%" size="lg" _hover={{ bg: "green.600" }}>
                  Submit Answers
                </Button>
              )}
              {isPdfEssayExam && essayQuestionCount > 0 && !isLastQuestion && hasAnsweredAll && (
                <Text fontSize="13px" color="gray.600" textAlign="center">
                  Go to the last question to submit and upload your PDF.
                </Text>
              )}
            </VStack>
          </Stack>
        </VStack>
      </Container>
      <ExamAnswersLoading />
      
      {/* Submit Confirmation Modal */}
      <Modal
        isOpen={isOpen}
        onClose={() => {
          onClose();
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Confirm Submission</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text fontSize="18px">
              Are you sure you want to submit your answers? This action cannot be undone.
            </Text>
            {isPdfEssayExam && (
              <Box mt={4}>
                <Text fontWeight="700" mb={2}>
                  Upload your PDF answer
                </Text>
                <Input
                  type="file"
                  accept="application/pdf,.pdf"
                  onChange={handlePdfChange}
                  p={1}
                  h="auto"
                />
                {studentPdf ? (
                  <Text mt={2} fontSize="sm" color="gray.600">
                    Selected: {studentPdf.name}
                  </Text>
                ) : (
                  <Text mt={2} fontSize="sm" color="red.500">
                    A PDF file is required to submit this exam.
                  </Text>
                )}
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button
              bg="green.500"
              color="white"
              isDisabled={isPdfEssayExam && !studentPdf}
              onClick={() => {
                if (isPdfEssayExam && !studentPdf) {
                  toast.error("Please upload a PDF before submitting");
                  return;
                }
                onClose();
                handelSendAnswers();
              }}
              _hover={{ bg: "green.600" }}
            >
              Yes, Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Layout>
  );
};

export default SolveExam;
